webpackJsonp([5246255234279],{

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResumeEntry = function ResumeEntry(props) {
	  var date = props.date,
	      title = props.title,
	      subtitle = props.subtitle;
	
	
	  return _react2.default.createElement(
	    "div",
	    { className: "row mt" },
	    _react2.default.createElement(
	      "div",
	      { className: "col-sm-4" },
	      _react2.default.createElement(
	        "strong",
	        null,
	        date
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "col-sm-8" },
	      _react2.default.createElement(
	        "h3",
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        subtitle
	      )
	    )
	  );
	};
	
	exports.default = ResumeEntry;
	module.exports = exports["default"];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ResumeEntry = undefined;
	
	var _ResumeEntry = __webpack_require__(108);
	
	var _ResumeEntry2 = _interopRequireDefault(_ResumeEntry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ResumeEntry = _ResumeEntry2.default;

/***/ }),

/***/ 141:
/***/ (function(module, exports) {

	module.exports = {"name":"Hanna","surname":"Neureuther","title":"Freiberufliche Sozialpädagogin/ Sozialarbeiterin und Philosophin","subtitle":"Verbindung von Praxis und Theorie mit über 10-jähriger Berufserfahrung","intro":"<p><i>“Das Handeln bedarf einer Pluralität, in der zwar alle dasselbe sind, nämlich Menschen, aber dies auf die merkwürdige Art und Weiße, dass keiner dieser Menschen je einem anderen gleicht, der einmal auf dieser Welt gelebt hat oder leben wird“</i></p><p>Hannah Arendt in Vita activa</p>","skills":{"area":["Mobiles Kinderprogramm und Veranstaltungsservice","Erwachsenenbildung","Familienhilfe","Offene Kinder- und Jugendarbeit","Sozialpädagogische Tätigkeit an Schulen","Vollstationäre Wohngruppen"],"soft":["Pluralität als Grundlage menschlichen Handelns, die uns Menschen verbindet","Ressourcen- und lebensweltorientiert","Partizipativ und empowernd","Systemisch fragend","Subjektwerdung reflektierend"],"perks":["Leitung und Konzeptionierung von Seminaren und Workshops z.B. zu Fragen der Gerechtigkeit und des moralischen Handelns für Jugendliche und Erwachsene","Teamleitung und -betreuung (auch auf Veranstaltungen)","Beratende Unterstützung von Fachkräften in ihrer Tätigkeit im sozialen Bereich","Anleitung von Auszubildenden und Studierenden","Arbeit mit (Groß-)Gruppen"]}}

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

	module.exports = {"experience":[{"when":"Seit 09.2016","what":{"title":"Leitung von Seminaren/Workshops","subtitle":"Seminare für Menschen in ihrem FSJ beim Wohlfahrtswerk für Baden-Württemberg. Workshops zu den Themen moralisches Handeln und Gerechtigkeit für junge Erwachsene."}},{"when":"Seit 02.2013","what":{"title":"Freiberufliche Tätigkeit","subtitle":"(Begleitung von Eltern und Kindern, Familienhilfe, Schüler*innen-Förderung, sozialpädagogische Unterstützung von Lehrenden im Unterricht, mobiles Kinderprogramm)."}},{"when":"05.2011 – 07.2012","what":{"title":"Sozialpädagogin (Gruppenleitung)","subtitle":"auf einer vollstationären Mädchenwohngruppe des ev. Hohberghauses in Bretten. Anleitung der Auszubildenden zur Jugend- und Heimerzieherin und Studentinnen der Sozialen Arbeit."}},{"when":"10.2010 – 04.2011","what":{"title":"Sozialpädagogin","subtitle":"an der Schule Enzberg, einer Schule für Erziehungshilfe. Eigenverantwortliche Betreuung einer Klasse mit intensiver Elternarbeit."}},{"when":"10.2008 - 07.2012","what":{"title":"Ehrenamtliche Tätigkeit als Dienst- und Fachaufsicht.","subtitle":"auf der Robinson Jugendfarm Botnang e.V.."}},{"when":"10.2007 - 09.2010","what":{"title":"Praxisphasen des dualen Studiums ","subtitle":"auf einer Wohngruppe des ev. Hohberghauses in Bretten."}},{"when":"09.2006 - 08.2007","what":{"title":"FSJ (Freiwilliges Soziales Jahr) ","subtitle":"auf einer Tagesgruppe für Jugendliche beim ev. Hohberghaus in Bretten."}},{"when":"Bis 2006","what":{"title":"Leitung von Sommerfreizeiten","subtitle":"für Kinder beim ev. Kinder- und Jugendwerk Mannheim. Tätigkeit im Seniorenzentrum Schwetzingen."}}],"education":[{"when":"10.2012 – 09.2017","what":{"title":"Bachelor-Studium Philosophie und Sozialwissenschaften (Zweitfach) ","subtitle":"an der Humboldt-Universität zu Berlin."}},{"when":"10.2007 - 09.2010","what":{"title":"Bachelor-Studium Sozialpädagogik/Soziale Arbeit ","subtitle":"an der Dualen Hochschule in Stuttgart."}}],"certifications":[{"when":"04.2012","what":{"title":"Methoden in der Mädchenpädagogik"}},{"when":"01.2010 - 04.2010","what":{"title":"Konflikthilfe und Gewaltprävention"}},{"when":"09.2008","what":{"title":"Grundlagen Erlebnispädagogik"}}]}

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(28);
	
	var _Containers = __webpack_require__(33);
	
	var _Resume = __webpack_require__(109);
	
	var _Card = __webpack_require__(45);
	
	var _aboutHannaDe = __webpack_require__(141);
	
	var _aboutHannaDe2 = _interopRequireDefault(_aboutHannaDe);
	
	var _cvHannaDe = __webpack_require__(594);
	
	var _cvHannaDe2 = _interopRequireDefault(_cvHannaDe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  var name = _aboutHannaDe2.default.name + " " + _aboutHannaDe2.default.surname;
	
	  var edu = _cvHannaDe2.default.education.map(function (entry) {
	    return _react2.default.createElement(_Resume.ResumeEntry, {
	      date: entry.when,
	      title: entry.what.title,
	      subtitle: entry.what.subtitle
	    });
	  });
	
	  var jobs = _cvHannaDe2.default.experience.map(function (entry) {
	    return _react2.default.createElement(_Resume.ResumeEntry, {
	      date: entry.when,
	      title: entry.what.title,
	      subtitle: entry.what.subtitle
	    });
	  });
	
	  var cert = _cvHannaDe2.default.certifications.map(function (entry) {
	    return _react2.default.createElement(_Resume.ResumeEntry, {
	      date: entry.when,
	      title: entry.what.title,
	      subtitle: entry.what.subtitle
	    });
	  });
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_Header.PageHeader, { title: name }),
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid content-row" },
	      _react2.default.createElement(
	        "div",
	        { className: "row mt" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4" },
	          _react2.default.createElement(_Card.SkillsCard, { skills: _aboutHannaDe2.default.skills.area, title: "Arbeitsfelder" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4" },
	          _react2.default.createElement(_Card.SkillsCard, { skills: _aboutHannaDe2.default.skills.soft, title: "Arbeitsweise" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-4" },
	          _react2.default.createElement(_Card.SkillsCard, { skills: _aboutHannaDe2.default.skills.perks, title: "Arbeitsschwerpunkte" })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "container-fluid content-row mb" },
	      _react2.default.createElement(
	        "div",
	        { className: "col-md-8 col-md-offset-2" },
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Ausbildung"
	        ),
	        edu,
	        _react2.default.createElement(
	          "h2",
	          { className: "pt" },
	          "Erfahrungen"
	        ),
	        jobs,
	        _react2.default.createElement(
	          "h2",
	          { className: "pt" },
	          "Zus\xE4tzliche Qualifikationen"
	        ),
	        cert
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-hanna-js-75fadc865f2ca177a36c.js